(function () {
  "use strict";

  angular
    .module("app")
    .directive("routeSyncPanel", routeSyncPanel);

  routeSyncPanel.$inject = [];

  function routeSyncPanel() {
    // Usage: Creates a routeSync panel that presents vehicles, and allows you to send a route sync package
    //
    var directive = {
      bindToController: true,
      controller: routeSyncPanelController,
      controllerAs: "rsCtrl",
      link: link,
      restrict: "E",
      templateUrl: "/app/route-sync/route-sync-panel/routeSyncPanel.template.html"
    };
    return directive;

    function link(scope, element, attrs) {
      scope.close = function () {
        scope.$parent.routeVm.hideRouteSync();
      };
    }
  }

  /* @ngInject */
  function routeSyncPanelController(vehicleService, routeService, mapService, alkGeocodeService, _, $scope, $timeout) {
    let vm = this;

    vm.complianceAmounts = [{
      "display": "Strict",
      "value": 0
    }, {
      "display": "Moderate",
      "value": 1
    }, {
      "display": "Minimum",
      "value": 2
    }];

    vm.isLoadingVehicles = false;
    vm.vehicleList = [];
    vm.selectedVehicle = null;
    vm.showSearch = false;
    vm.searchText = "";
    vm.currentRoute = null;
    vm.routeSyncOptions = {
      "alertDist": 0.2,
      "complianceAmount": vm.complianceAmounts[0].value
    };

    vm.filterVehicles = filterVehicles;
    vm.cancelSearch = cancelSearch;
    vm.getVehicles = getVehicles;
    vm.getSelectedVehicle = getSelectedVehicle;
    vm.setSelectedVehicle = setSelectedVehicle;
    vm.showLocation = showLocation;
    vm.frameClosest = frameClosest;
    vm.getClosestToOrigin = getClosestToOrigin;
    vm.frameRouteAndVehicle = frameRouteAndVehicle;
    vm.send = send;

    init();

    function getSelectedVehicle() {
      return vm.selectedVehicle;
    }

    function setSelectedVehicle(vehicle) {
      vm.selectedVehicle = vehicle;
    }

    function showLocation(vehicle, pan) {
      if (!pan) {
        pan = false;
      }

      if (!vehicle.Latitude || !vehicle.Longitude) {
        return;
      }

      alkGeocodeService.reverseGeocode({
          "lat": vehicle.Latitude,
          "lon": vehicle.Longitude
        })
        .then(function (data) {
          vehicle.Address = data[0].Address;
          vehicleService.showVehicle(vehicle, pan, this);
        });
    }

    function frameClosest() {
      var closest = getClosestToOrigin();
      frameRouteAndVehicle(closest);
      setSelectedVehicle(closest);
    }

    function getClosestToOrigin() {
      var selRouteOrigin = vm.route.stops[0].Coords;
      var oPoint = new ALKMaps.Geometry.Point(selRouteOrigin.Lon, selRouteOrigin.Lat);
      var closest = _.min(vm.vehicleList, function (v) {
        var vPoint = new ALKMaps.Geometry.Point(v.Longitude, v.Latitude);
        return vPoint.distanceTo(oPoint);
      });
      return closest;
    }

    function frameRouteAndVehicle(vehicle) {
      showLocation(vehicle, false);
      var routeElements = mapService.getRouteElements(vm.route.id);
      var mapObj = mapService.getMap();
      var vehLL = new ALKMaps.LonLat(vehicle.Longitude, vehicle.Latitude).transform(new ALKMaps.Projection("EPSG:4326"), mapObj.getProjectionObject());
      var routeExtent = routeElements.routingLayer.getDataExtent();
      routeExtent.extend(vehLL);
      mapObj.zoomToExtent(routeExtent);
    }

    function send() {
      var currentVehicle = getSelectedVehicle();
      if (!currentVehicle) {
        return;
      }

      vm.routeSyncOptions.ownerId = currentVehicle.OwnerID;
      vm.routeSyncOptions.routeId = vm.route.id;
      vehicleService.sendRSMessage(vm.routeSyncOptions)
        .then(() => {
          vm.displaySuccessMessage = true;
          vm.displayErrorMessage = false;
          $timeout(() => {
            $scope.$parent.routeVm.hideRouteSync();
          }, 3000);
        }, () => {
          vm.displaySuccessMessage = false;
          vm.displayErrorMessage = true;
        });
    }

    function filterVehicles() {
      vm.showSearch = !vm.showSearch;
    }

    function cancelSearch() {
      vm.searchText = "";
      vm.showSearch = false;
    }

    function getVehicles() {
      vehicleService
        .getVehicleList()
        .then((vehicleList) => {
          vm.vehicleList = vehicleList;
        }, (err) => {
          console.error(err);
          vm.vehicleList = [];
        });
    }

    function init() {
      getVehicles();
      vm.route = angular.copy(routeService.getSelectedRoute());
    }
  }
})();



// WEBPACK FOOTER //
// ./app/route-sync/route-sync-panel/routeSyncPanel.directive.js